import Select from "react-select";
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label:  "Interna" },
    { value: 2, label:  "Externa" },
];

const TipoUcVinculada = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select
            options={options}
            {...field}
            styles={{
                ...SearchFieldStyles,
                menuPortal: base => ({
                    ...base,
                    zIndex: 9999
                })
            }}
            menuPortalTarget={document.body}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
            className={className}
            isSearchable={false}
        />
    )
}

export { TipoUcVinculada, options as OpcoesTipoUcVinculada }